import React, { useEffect, useState } from "react";
import "./Login.css";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import axiosInstance from "../../axiosinterceptor";
import { useAuth } from "../../authContext/AuthContext";
// import { authenticate } from "../../authContext/CognitoAuth"; 
import { BiLoader, BiShow, BiHide } from "react-icons/bi";
import ForgotPassword from "../forgotpassword/ForgotPassword";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import microsoftIcon from "../../../src/assets/microsoft.png";
import { configData } from "../Navbar/config";
import { CircularProgress } from "@mui/material";
import { clearCodebookFromIndexedDB } from "../../utils/indexedDB";


function Login({ setShowLogin }) {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  // console.log(params, "params");
  const hcpLineID = params.get("hcp_line_id");
  // console.log(hcpLineID, "hcpLineID");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showLoginPage, setShowLoginPage] = useState(true);
  const { setIsAuthenticated, setUserEmail, setPermissions } = useAuth();
  // const SSOLogin_coblhEnv = process.env.REACT_APP_FLAG_COBLH_DEV;
  const SSOLogin_devEnv = process.env.REACT_APP_FLAG_DEV;
  const SSO_DEVURL = "https://hcs.pallas-ai.com.au";
  // const SSO_COBLHURL = "https://coblh-dev.imedx.com.au";
  const [showPassword, setShowPassword] = useState(false);
  const SSOCODE = params.get("code");
  const loginFunctionHandler = async (payload = {}) => {
    setLoading(true);
    setError("");
    clearCodebookFromIndexedDB();
    sessionStorage.removeItem("isFetched12");
    sessionStorage.removeItem("isFetched13");
  sessionStorage.removeItem("initialprincipalDiagnosisState");
  sessionStorage.removeItem("initialadditionalDiagnosisState");
  sessionStorage.removeItem("initialprocedureDiagnosisState");

    const payloadToSend = SSOCODE
      ? {code: SSOCODE }
      : {
      username: payload?.username,
      password: payload?.password,
    };
    try {
      // "admin_login_users_acs",
      const response = await axiosInstance.post(
        SSOCODE ? "sso_authenticator"
        // "https://r42p91y8a4.execute-api.ap-southeast-2.amazonaws.com/dev/testlambda_sk"
         : "admin_login_users_acs",
        payloadToSend
      );
      setLoading(false);

      if (response.data.statusCode !== 400) {
        // console.log(response.data.body, "%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%")
       if (SSOCODE) {
        localStorage.setItem("LAST_SUCCESSFUL_LOGIN", "SSO");
        sessionStorage.removeItem("PENDING_SSO");
        sessionStorage.removeItem("AUTO_SSO_ATTEMPTED");
      }
        else{
        localStorage.setItem("LAST_SUCCESSFUL_LOGIN", "LOCAL");
      }
        const { accessToken, refreshToken, message, permissions, user_email, name, user_id, organization_id, country_id } = response.data.body; // No need to parse
        //console.log('checkrepsonse',response.data.body,organization_id,country_id);
        // Show success message
        toast.success(message);

        // Store tokens and user info in session storage
        sessionStorage.setItem("loginSession", accessToken);
        sessionStorage.setItem("accessToken", accessToken);
        sessionStorage.setItem("refreshToken", refreshToken);
        sessionStorage.setItem("useremail", user_email); // Save email from response
        sessionStorage.setItem("username",name)
        sessionStorage.setItem("userId", user_id); // Save email from response
        setUserEmail(user_email); // Set email in AuthContext
        sessionStorage.setItem("organizationId", organization_id);
        sessionStorage.setItem("countryId", country_id);
        // console.log(user_id,"***************************!!!!!!!!!!!!!!!!!");
        // Store theme preference in session storage
        sessionStorage.setItem("mode", "DARK"); // Set theme mode

        // Store permissions if available
        if (permissions) {
          sessionStorage.setItem("permissions", JSON.stringify(permissions)); // Store permissions in session storage
          setPermissions(permissions); // Update permissions in context
        }
        // console.log(hcpLineID, "hcpLineID", process.env.REACT_APP_FLAG_USA);
        if (process.env.REACT_APP_FLAG_USA === "usa" && hcpLineID) {
          sessionStorage.setItem("last_hcp_line_id", hcpLineID);
          sessionStorage.setItem("episodeHcpLineId", hcpLineID);
          sessionStorage.setItem("currentPage", "episodeList");
          // sessionStorage.setItem("enableHCPQueryParamsFunctionality", true);
          navigate("/coder");
        } else {
          // sessionStorage.setItem("enableHCPQueryParamsFunctionality", false);
          navigate("/");
        }

        // Update sessionStorage storage and state
        sessionStorage.setItem("isAuthenticated", "true");
        setIsAuthenticated(true);
      } else {
        if (SSOCODE) {
        localStorage.removeItem("LAST_SUCCESSFUL_LOGIN");
        sessionStorage.removeItem("PENDING_SSO");
        sessionStorage.removeItem("AUTO_SSO_ATTEMPTED");
    }
        toast.error(JSON.parse(response.data.body || "login failed"));
      }
    } catch (error) {
      if (SSOCODE) {
        localStorage.removeItem("LAST_SUCCESSFUL_LOGIN");
        sessionStorage.removeItem("PENDING_SSO");
        sessionStorage.removeItem("AUTO_SSO_ATTEMPTED");
    }
      setLoading(false);
      console.error(error);
      toast.error("Login failed, please try again.");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    loginFunctionHandler({ username, password });
  };
  const handleMicrosoftLogin = () => {
    const redirectUri = SSOLogin_devEnv
  ? SSO_DEVURL
  // : SSOLogin_coblhEnv
  //   ? SSO_COBLHURL
    : "";
    const redirectURL = `https://ap-southeast-2qaj4mzg1x.auth.ap-southeast-2.amazoncognito.com/oauth2/authorize?client_id=2412c4nvn033h8eonph7e5lhfc&response_type=code&scope=openid+email+profile+aws.cognito.signin.user.admin&redirect_uri=${redirectUri}/&identity_provider=microsoft-azuread-sso-saml`
     window.location.href = redirectURL;
  };


useEffect(() => {
  if (!SSOLogin_devEnv) return;
    const isLoggingOut = localStorage.getItem("isLoggingOut") === "true";

  const pendingSSO = sessionStorage.getItem("PENDING_SSO") === "true";
  const lastLogin = localStorage.getItem("LAST_SUCCESSFUL_LOGIN");
  const autoAttempted = sessionStorage.getItem("AUTO_SSO_ATTEMPTED") === "true";
  // Don't auto-login after logout
  if (isLoggingOut) {
    return;
  }

  if (SSOCODE) {
    loginFunctionHandler();
    return;
  }

  if (
    lastLogin === "SSO" &&
    !pendingSSO &&
    !autoAttempted
  ) {
    sessionStorage.setItem("AUTO_SSO_ATTEMPTED", "true");
  handleMicrosoftLogin();
  }

}, [SSOCODE]);


  const onMicrosoftLogin = () => {
    localStorage.removeItem("isLoggingOut");
    sessionStorage.removeItem("AUTO_SSO_ATTEMPTED");
    sessionStorage.setItem("PENDING_SSO", "true");
    handleMicrosoftLogin();
  };
  return (
    <>
      {SSOCODE ? (
        <div className="login-container-usa" role="dialog" aria-modal="true">
          <div className="login-loader-modal">
            <div className="login-loader-body">
              <CircularProgress />

              <div className="login-loader-content">

                <p className="login-loader-text">
                  <img
                    alt="microsoftIcon"
                    src={microsoftIcon}
                    className="loader_microsoft_icon"
                  />
                    Authenticating your Microsoft account...
                </p>
                <p className="login-loader-text">
                  {/* Please wait... */}
                    Please wait while we securely connect to your workspace
                </p>
              </div>
            </div>
          </div>
        </div>
      ) : showLoginPage ? (
        <div className="login-container-usa">
          <ToastContainer autoClose={20000} />
          <form className="login-form" onSubmit={handleSubmit}>
            <h2 className="login-header">Login</h2>
            <div className="input-group">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => {
                  setUsername(e.target.value);
                  setError("");
                }}
                disabled={loading}
              />
            </div>
            <div
              className="input-group"
              style={{
                display: "flex",
                alignItems: "center",
                position: "relative",
              }}
            >
              <label htmlFor="password">Password</label>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError("");
                }}
                disabled={loading}
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "10px",
                  cursor: "pointer",
                  color: "#888",
                  top: "50%",
                }}
              >
                {showPassword ? <BiHide /> : <BiShow />}
              </span>
            </div>
            <button
              className="Login-btn btn btn-warning"
              type="submit"
              disabled={loading}
            >
              {loading && !error ? <BiLoader /> : "Log In"}
            </button>
            <div>
              <p className="switchSignUp">
                Don't have an account?{" "}
                <span onClick={() => setShowLogin(true)}> Sign Up</span>
              </p>
            </div>
            <p
                className="forgotPassword"
                onClick={() => {
                  setShowLoginPage(false);
                }}
              >
                Forgot Password?
              </p>
              <>
            { SSOLogin_devEnv 
            // SSOLogin_coblhEnv
             && 
             <>
              <p className="login_divider_text">OR CONTINUE WITH</p>
            <button
              className="microsoft-login-btn"
              type="button"
              disabled={loading}
              onClick={onMicrosoftLogin}




              >
              <img
                alt="microsoftIcon"
                src={microsoftIcon}
                className="login_microsoft_icon"
              />
              Login in with Microsoft
            </button>
            {error && <p className="login-errorMessage">{error}</p>}</>
              }
            </>
          </form>
        </div>
      ) : (
        <ForgotPassword setShowLoginPage={setShowLoginPage} />
      )}
    </>
  );
}

export default Login;
